import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AlertProvider, GlobalErrorBoundary } from "@workspace/shared";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import AppRoutes from "./routes";
import { PermissionProviderWrapper } from "./providers/PermissionProviderWrapper";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("app")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <GlobalErrorBoundary>
            <AlertProvider>
              <PermissionProviderWrapper>
                <AppRoutes />
              </PermissionProviderWrapper>
            </AlertProvider>
          </GlobalErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
);
